import { custom, entities, users } from "@/locales/fr";
import polyglotI18nProvider from "ra-i18n-polyglot";
import frenchMessages from "ra-language-french";

const messages = {
  ...frenchMessages,
  ra: {
    ...frenchMessages.ra,
    page: {
      ...frenchMessages.ra.page,
      create: "Création de %{name}",
      edit: "Modification de %{name}",
    },
    users,
    entities,
    ...custom,
  },
};

const i18nProvider = polyglotI18nProvider(() => messages, "fr");

export { i18nProvider };
